module.exports = __webpack_public_path__ + "img/workload-word-cloud.59d43cd8.png";